export default {
products_search: "Search products...",
      stock: "Stock",
      in_stock: "In Stock",
      low_stock: "Low Stock",
      out_of_stock: "Out of Stock",
      expiry: "Expiry",
      valid: "Valid",
      expired: "Expired",
      offer: "Offer",
      country: "Country",
      reset: "Reset",
      view_inactive: "View Inactive Products",
      hide_inactive: "Hide Inactive Products",
      restore: "Restore",

      deactivate_product: "Deactivate Product",
      confirm_deactivate: "Are you sure you want to deactivate",
      cancel: "Cancel",
      yes_deactivate: "Yes, Deactivate",

      price: "Price",
      Supcurrency: "Currency",
      units: "Units",
      uom: "UOM",
      moq: "MOQ",
      offer_valid: "Offer Valid",
      offer_time: "Offer Time",
      offer_starts: "Offer Starts",
      currency_code: "QAR",
      ends_in: "Ends in {{count}} min",
starts_in: "Starts in {{count}} min",
starts_tomorrow: "Starts tomorrow",
starts_days: "Starts in {{count}} days",
upcoming: "Upcoming",
percent_off: "{{value}}% OFF",
flat_off: "{{value}} OFF",
buy_get: "Buy {{buy}} Get {{get}}",
offer: "Offer",
percentage: "Percentage",
flat: "Flat",
bogo: "Buy 1 Get 1",
no_offer: "No Offer",
product_actions: "Product Actions",
stock_quantity: "Stock Quantity",
price_per_unit: "Price per unit",
expiry_date: "Expiry Date",
expiry_time: "Expiry Time",
minimum_order_quantity: "Minimum Order Quantity",
unit_of_measure: "Unit of Measure",
existing_images: "Existing Images",
choose_images: "Choose Images",
back: "Back",
save: "Save",
edit_inventory: "Edit Inventory",
manage_offer: "Manage Offer",
close: "Close",
deactivate_product: "Deactivate Product",
confirm_deactivate: "Are you sure you want to deactivate?",
cancel: "Cancel",
yes_deactivate: "Yes, Deactivate",
edit_offer: "Edit Offer",
create_offer: "Create Offer",
offer_title: "Offer Title",
description: "Description",
offer_type: "Offer Type",
select_offer_type: "Select Offer Type",
discount_percentage: "Discount Percentage (%)",
flat_discount: "Flat Discount Amount",
buy_quantity: "Buy Quantity",
get_quantity: "Get Quantity",
start_date: "Start Date",
end_date: "End Date",
start_time: "Start Time",
end_time: "End Time",
status: "Status",
toggle_offer: "Deactivate / Activate this offer",
update_offer: "Update Offer",
add_product: "Add New Product",
manage_product_info: "Manage your product information",
bulk_upload: "Bulk Upload",
business_details: "Business Details",
company_name: "Company Name",
supbranch: "Branch",
select_branch: "Select Branch",
supstore: "Store",
select_store: "Select Store",

product_details: "Product Details",
product_name_en: "Product Name (EN)",
product_name_ar: "Product Name (AR)",
category: "Category",
select_category: "Select Category",
sub_category: "Sub Category",
select_subcategory: "Select Subcategory",
select_unit: "Select Unit",

pricing_availability: "Pricing & Availability",
stock_available: "Stock Available",
shelf_life: "Shelf Life (days)",

product_images: "Product Images",
drag_drop_images: "Drag & drop images here",
click_upload: "or click to upload",

save_product: "Save Product",

product_name_required: "Product name is required",
supplier_not_logged: "Supplier not logged in",
product_added_success: "Product added successfully",
product_failed: "Failed to save product",
  "product_name_english": "Product Name (English)",
  "product_name_arabic": "Product Name (Arabic)",
  delivery_time_minutes: "Delivery Time",
};